module.exports = __webpack_public_path__ + "img/DSC_1097.9e5be423.jpg";